import React from 'react';

import {
  Link,
  Divider,
  Box,
  Typography,
  Card,
  useWindowSize,
} from 'vindi-ds-components';
import styles from '../styles';

function reportCard({
  name, icon, links, marginCard, heightCard,
}) {
  const windowSize = useWindowSize();
  const { isMobile } = windowSize;

  const lastLink = links.length - 1;

  return (
    <Box mb={marginCard}>
      <Box display='flex' gap={1} height='2em' mb={2} alignItems='center'>
        <Box style={styles.icon}>{icon}</Box>
        <Typography variant={isMobile ? 'subtitle1' : 'h5'} component='p'>
          {name}
        </Typography>
      </Box>

      <Card padding='xs' width={isMobile ? '100%' : '30,5em'} height={heightCard}>
        {links.map((link, index) => (
          <Box key={link.route}>
            <Link href={link.route}>{link.label ?? name}</Link>

            {index !== lastLink && (<Divider spacing='xxs' />)}
          </Box>
        ))}
      </Card>
    </Box>
  );
}

export default reportCard;
